module.exports = __webpack_public_path__ + "img/81600.01e3fb30.jpg";